import React from 'react';
import { Col, Container, Row, Accordion } from 'react-bootstrap';
import {NYCPin} from "../../../../app-constants";
import {Link} from 'gatsby';
import FaqComponents from "../../components/common/faq";

const faqs = [
    {
        question: "How much does it cost to develop a mobile phone app?",
        answer: `<p>Some apps cost as little as $5,000 to develop, while others cost over $1 million!</p> <p>The expenses involved in app development may significantly differ, influenced by factors such as the scale and complexity of the app under development. The development costs will increase as the complexity and features of your app grow.</p>`,
    },
    {
        question: "How much does it cost to run an app per month?",
        answer: `<p>On average, app owners should expect an initial monthly expenditure of approximately $250 to $500 to ensure optimal functionality and performance of the app.</p> <p>Moreover, a common rule of thumb for the cost of running an app is to allocate 20% of the initial development cost for ongoing maintenance.</p>`,
    },
    {
        question: "How long does it take to develop a mobile app?",
        answer: ` <p>The duration of developing an app is dependent on the complexity of the app.</p> <p>For instance, a compact app can be developed in 2 months, a medium-sized app can take around 3 - 3.5 months while a larger-scale app might take around 5 - 6 months.</p>`,
    },
    {
        question: "What is your app development process?",
        answer: `<p>TekRevol's app development process involves strategic planning, meticulous design and branding, precise coding and development, a successful launch, ongoing maintenance, and continuous optimization to ensure your app stays at its peak performance.</p>`,
    },
    
];

function FaqLocation(props) {
    return (
        <div className="faq_loc p-100 tekrevol_dark_bg">
            <Container className="h-100">
                <Row className="h-100">
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        xl={10}
                        xxl={10}
                        className="m-auto text-center"
                    >
                        <div className="example center text-center" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="h-100">
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        xl={12}
                        xxl={12}
                        className="services_faqs"
                    >
                        <FaqComponents faqs={faqs} />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default FaqLocation;